import axios from "axios";

export default async function uploadFile(uploadURL: string, file: File, onProgress: (uploadedBytes: number, totalBytes: number) => void) {
    return axios.put(
        uploadURL,
        file,
        {
            headers: {
                "Content-Type": file.type,
                "x-ms-blob-type": "BlockBlob",
            },
            onUploadProgress(event) {
                onProgress?.(event.loaded, event.total);
            },
        },
    );
}
